export default function wireProductListeners() {
  const segment = useSegmentHelper()
  const { $uiEvents } = useNuxtApp()

  $uiEvents.$on('CapBuilderPDPClick', (data: ProductLine) => {
    segment.track('Cap Builder PDP Click', formatTrackingInfo(data))
  })

  $uiEvents.$on('CapBuilderPDPViewed', (data: ProductLine) => {
    segment.track('Cap Builder PDP Viewed', formatTrackingInfo(data))
  })

  $uiEvents.$on('CapBuilderAnalyticsEvent', (data: any) => {
    segment.track(`capbuilder:${data.event}`, data)
  })

  function formatTrackingInfo(data: ProductLine) {
    return {
      productLineSlug: data.productLineSlug,
      productName: data.name,
    }
  }
}
